<template>
    <div class="page-content plan-afaceri-wrapper">
        <SketchBreadcrumb pageName="Plan de afaceri"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box flex space-between align-center">
                <div ref="scrollTo">
                    <h3 class="module-title">Completează cu atenție secțiunile de mai jos. Planul de afaceri va fi generat în formatul anexei 4.2</h3>
                    <p>Aceaste informații vor fi introduse in sistemul informatic MySmis. </p>
                </div>
                <img src="@/assets/images/M3/M3Sketch/warning-sign.png" class="warning-sign">
            </div>
            <M3Warn v-if="allData && allData.m3_project && allData.m3_project.duplicate_sections && allData.m3_project.duplicate_sections.includes('business_plan')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(allData.m3_project.duplicate_company_id)"></M3Warn>
            <PlanAfaceriContent :allData.sync="allData" :completed="completed" :statistics="statistics" @unsavedChanges="inputsChanged = $event; $emit('unsavedChanges', inputsChanged)" @formComplete="completePage($event, true)" @formIncomplete="completePage($event, false)"></PlanAfaceriContent>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>
        <ChangeRoutePopup :schimbaModal="showModal"
                          @hideTempModal="showModal = false"
                          @changeRoute="leavePage($event)"
        ></ChangeRoutePopup>
    </div>
</template>

<script>
    import PlanAfaceriContent from '../components/plan-afaceri/PlanAfaceriContent'
    import ChangeRoutePopup from "../components/ChangeRoutePopup";
    import {changeRoute} from "../../../../../helpers/helpers";
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import { BIconChevronUp } from 'bootstrap-vue'
    import M3Warn from "../components/M3Warn";

    export default {
        components: {
            PlanAfaceriContent,
            ChangeRoutePopup,
            SketchBreadcrumb,
            BIconChevronUp,
            M3Warn

        },
        data() {
            return {
                completed: false,
                showModal: false,
                next: null,
                inputsChanged: false,
                completedPage:{
                    scop: false,
                    situatie: false,
                    obiective: false,
                    mediuExtern: false,
                    analizaSWOT: false,
                    etape: false,
                    contributiaMediului: false,
                    riscuri: false
                }
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch:{
            completed(newValue, oldValue){
                if(newValue !== oldValue && newValue > 0){
                    this.inputsChanged = false;
                    this.$emit('unsavedChanges', this.inputsChanged);
                }

            }
        },
        mounted() {

            if(this.allData && this.allData.m3_project){
                this.completedPage = {
                    scop: this.allData.m3_project.business_plan_scope ? this.allData.m3_project.business_plan_scope.checked : false,
                    situatie: this.allData.m3_project.business_plan_initial_state ? this.allData.m3_project.business_plan_initial_state.checked : false,
                    obiective: this.allData.m3_project.business_plan_objectives ? this.allData.m3_project.business_plan_objectives.checked : false,
                    mediuExtern: this.allData.m3_project.business_plan_external_environment ? this.allData.m3_project.business_plan_external_environment.checked : false,
                    analizaSWOT: this.allData.m3_project.business_plan_swot ? this.allData.m3_project.business_plan_swot.checked : false,
                    etape: this.allData.m3_project.business_plan_stages_targets ? this.allData.m3_project.business_plan_stages_targets.checked : false,
                    contributiaMediului: this.allData.m3_project.business_plan_green_environment ? this.allData.m3_project.business_plan_green_environment.checked : false,
                    riscuri: this.allData.m3_project.business_plan_risks ? this.allData.m3_project.business_plan_risks.checked : false
                }
            }
            this.checkCompleted();

        },
        beforeRouteLeave (to, from, next) {

            this.next = next;
            if(to.path === '/login' || to.path === '/logout')
                this.next();

            if(this.completed)
                this.next();

            if(this.inputsChanged)
                this.showModal = this.inputsChanged;

            if(!this.showModal)
                this.next();

        },
        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            completePage(event, status) {

                switch (event){

                case 'scop':
                    this.completedPage.scop = status;
                    break;

                case 'situatie':
                    this.completedPage.situatie = status;
                    break;

                case 'obiective':
                    this.completedPage.obiective = status;
                    break;

                case 'mediuExtern':
                    this.completedPage.mediuExtern = status;
                    break;

                case 'analizaSWOT':
                    this.completedPage.analizaSWOT = status;
                    break;

                case 'etape':
                    this.completedPage.etape = status;
                    break;

                case 'contributiaMediului':
                    this.completedPage.contributiaMediului = status;
                    break;

                case 'riscuri':
                    this.completedPage.riscuri = status;
                    break;

                }
                if(status){
                    this.$emit('updateData')
                }
                this.checkCompleted();
            },

            checkCompleted(){

                this.completed = this.$store.getters['checks/checks'].planDeAfaceriAnalizaSwot && this.$store.getters['checks/checks'].planDeAfaceriEtapeTinte && this.$store.getters['checks/checks'].planDeAfaceriScop && this.$store.getters['checks/checks'].planDeAfaceriSituatie && this.$store.getters['checks/checks'].planDeAfaceriRiscuri && this.$store.getters['checks/checks'].planDeAfaceriMediuExtern && this.$store.getters['checks/checks'].planDeAfaceriContributieMediu

                this.section = {
                    section: 'plan-de-afaceri'
                }

                if(this.completed){
                    this.$store.dispatch('pages/addPage', this.section)
                }
                else{
                    this.$store.dispatch('pages/removePage', this.section)
                }

            },

            checkForInputs(){
                let elements = document.getElementsByTagName('textarea');

                for(let i = 0; i < elements.length; i++){
                    if(elements[i].value && !this.$attrs.completePages.length)
                    {
                        this.unsavedChanges = true;
                        break;
                    }
                }
            },

            leavePage(event){
                changeRoute(event, this.next);

                if(!event)
                    this.showModal = false;
            },

            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
        }
    }
</script>
<style>
@media screen and (max-width: 1367px) {
  .plan-afaceri-wrapper hr.mt-5 {
    margin-top: 1rem!important;
  }
}
</style>
<style scoped>
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 99999;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}
</style>
